import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import * as Columns from 'support/columns'
import { Translation } from '@morningtrain/react-translations'

export default function GoodsUsageTableFooter () {
  return (
    <tr>
      <Columns.Column>
        <Translation name='generic.total'/>
      </Columns.Column>


      <Columns.Column alignment='right'>

        <UI.SplitValues splitter={'/'}
                        secondary={
                          <>
                            <Displays.Aggregate
                              name='kitchen_revenue'
                              display={
                                <Displays.Currency decimals={0} defaultValue={0}/>}/> | <Displays.AggregateRatio
                            name='kitchen'
                            outOfName='kitchen_revenue'
                            display={<Displays.Percentage decimals={0}/>}
                          />
                          </>
                        }>
          <Displays.Aggregate name='kitchen' display={<Displays.Currency defaultValue={0} decimals={0}/>}/>
        </UI.SplitValues>

      </Columns.Column>

      <Columns.Column alignment='right'>

        <UI.SplitValues splitter={'/'}
                        secondary={
                          <>
                            <Displays.Aggregate
                              name='bar_revenue'
                              display={
                                <Displays.Currency decimals={0} defaultValue={0}/>}/> | <Displays.AggregateRatio
                            name='bar'
                            outOfName='bar_revenue'
                            display={<Displays.Percentage decimals={0}/>}
                          />
                          </>
                        }>
          <Displays.Aggregate name='bar' display={<Displays.Currency defaultValue={0} decimals={0}/>}/>
        </UI.SplitValues>

      </Columns.Column>


      <Columns.Column alignment='right'>

        <UI.SplitValues splitter={'/'}
                        secondary={
                          <>
                            <Displays.Aggregate
                              name='total_revenue'
                              display={
                                <Displays.Currency decimals={0} defaultValue={0}/>}/> | <Displays.AggregateRatio
                            name='total'
                            outOfName='total_revenue'
                            display={<Displays.Percentage decimals={0}/>}
                          />
                          </>
                        }>
          <Displays.Aggregate name='total' display={<Displays.Currency defaultValue={0} decimals={0}/>}/>
        </UI.SplitValues>

      </Columns.Column>
    </tr>
  )
}
